import { webCoreTypes } from "@core/core-types.di";
import { FallbackError } from "@core/domain/errors/fallback.error";
import type { IotApiClient } from "@iot-platform/core";
import type { GraphDto } from "@station/data/dto/graph.dto";
import { GraphMapper } from "@station/data/mappers/graph.mapper.ts";
import type {
    Graph,
    GraphFilters,
} from "@station/domain/models/graph.model.ts";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class GraphDatasource {
    static readonly GRAPH_PATH = "/stations/:stationId/graph";

    constructor(
        @inject(webCoreTypes.infrastructure.IotApiClient)
        private readonly iotApiClient: IotApiClient,
        @inject(GraphMapper)
        private readonly graphValueMapper: GraphMapper,
    ) {}

    fetchAll(): ResultAsync<Graph[], FallbackError> {
        return this.iotApiClient.http
            .get<GraphDto>(GraphDatasource.GRAPH_PATH)
            .mapErr(() => new FallbackError())
            .map((response) => this.graphValueMapper.map(response.data));
    }

    fetchById(filter: GraphFilters): ResultAsync<Graph[], FallbackError> {
        const url = `/stations/${filter.stationId}/graph?variable_ids=${filter.sensorIds.join(",")}&from=${filter.from}&to=${filter.to}`;
        return this.iotApiClient.http
            .get<GraphDto>(url)
            .mapErr(() => new FallbackError())
            .map((response) => this.graphValueMapper.map(response.data));
    }
}
